import {SearchOrderType} from "./search-order-type";

export class EntitySearchCriteria {

  entityName!: string;
  searchTerm!: string;
  orgUnitId!: string;
  personId!: string;
  searchOrderType: SearchOrderType = SearchOrderType.ALL;
  region!: string;
  approvalStatusCode!: string;
  lastUpdate!: string;

}
